module.exports = __webpack_public_path__ + "static/media/hero-bg.fbfa77c0.svg";